import { render, staticRenderFns } from "./customer-subscriptions.vue?vue&type=template&id=6a150bda&"
import script from "./customer-subscriptions.vue?vue&type=script&lang=js&"
export * from "./customer-subscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports